<div *ngIf="robotConfigurations">
  <div class="sort-wrapper">
    <div class="sort-chips">
      <span style="color: rgba(7, 10, 23, 0.6); margin-right: 1em"
        >SORT BY</span
      >
      <button
        mat-stroked-button
        (click)="sorterSelected(sort)"
        *ngFor="let sort of sortOptions"
        [ngStyle]="{
          'background-color': sort.selected ? '#395692' : '#E0E0E0'
        }"
      >
        {{ sort.label }}
      </button>
    </div>
    <div class="search-textfield">
      <mat-form-field>
        <mat-label>Search:</mat-label>
        <input matInput (keyup)="applyFilter($event)" #input />
      </mat-form-field>
      <mat-icon>search</mat-icon>
    </div>
  </div>

  <ng-container *ngFor="let config of displayedConfigs[currentPage]">
    <app-card-robot-config
      [robotConfig]="config"
      [selected]="cardSelected(config)"
      (click)="selectCard(config)"
    >
    </app-card-robot-config>
  </ng-container>

  <ng-container *ngIf="!robotConfigurations.length">
    <p>There are no configurations matching filters. Create one.</p>
  </ng-container>

  <div class="card-page-wrapper">
    <button
      mat-icon-button
      (click)="pageChange(-1)"
      [disabled]="incrementPageDisabled(0)"
    >
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>

    <ng-container *ngFor="let page of pages">
      <button
        mat-flat-button
        pally-icon-button-m
        [ngClass]="{ selected: currentPage === page }"
        [disabled]="currentPage === page"
        (click)="currentPage = page"
      >
        {{ page + 1 }}
      </button>
    </ng-container>

    <button
      mat-icon-button
      color="primary"
      (click)="pageChange(1)"
      [disabled]="incrementPageDisabled(pages.length - 1)"
    >
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  </div>
</div>
